export const UNSUBSCRIBE_NEWSLETTER = 'containers/UnsubscribeNewsletterPage/UNSUBSCRIBE_NEWSLETTER';
